import { FlatPresetData } from '@src/store/ifl-flat';
import { InsuranceSubproducts } from '@src/types';
import { getPresetDefaultInsuranceSum } from '@src/utils';

export const createSubProductsFromPresetData = (
  presetData: FlatPresetData,
  subproducts: InsuranceSubproducts
): InsuranceSubproducts => {
  const newSubObjects = subproducts.subObjects.map((item) => ({
    ...item,
    defaultInsuranceSum: getPresetDefaultInsuranceSum(
      presetData.subObjects.find(({ code }) => code === item.code)
        ?.defaultInsuranceSum,
      item
    ),
  }));

  return {
    ...subproducts,
    subObjects: newSubObjects,
  };
};
